export default __webpack_public_path__ + "static/media/sms-icon.2fa3510d.png";